import {createRouter, createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import JoinView from "@/views/join/JoinView.vue";
import UserView from "@/views/user/UserView.vue";
import UserCard from "@/views/user/CardView.vue";
// import CardView from "@/views/user/CardView.vue";
import PrefillView from "@/views/user/PrefillView.vue";
import AntiFraudView from "@/views/agreement/AntifraudView.vue";

import PrivacyView from "@/views/agreement/PrivacyView.vue";
import AgreementView from "@/views/agreement/AgreementView.vue";
import ServicesView from "@/views/agreement/ServicesView.vue";

import FmAgreement from "@/views/agreement/fmqy/AgreementView.vue";
import FmPrivacy from "@/views/agreement/fmqy/PrivacyView.vue";
import FmServices from "@/views/agreement/fmqy/ServicesView.vue";

import FmAntifraud from "@/views/agreement/fmqy/AntifraudView.vue";
import FmIdentity from "@/views/agreement/fmqy/IdentityView.vue";

import FaceView from "@/views/agreement/FaceView.vue";
import ExtendView from "@/views/agreement/ExtendView.vue";
import PolicyView from "@/views/join/PolicyView.vue";
import DownloadView from "@/views/download/DownloadView.vue";
import InstructionView from "@/views/agreement/InstructionView.vue";
import CallSelectView from "@/views/call/SelectView.vue";
import CallReloadView from "@/views/call/ReloadView.vue";
import CallApplyView from "@/views/call/ApplyView.vue";
import CallCancelView from "@/views/call/CancelView.vue";
import ActivityView from "@/views/activity/ActivityView.vue";
import PayView from "@/views/pay/PayView.vue";
import AliView from "@/views/callback/AliView.vue";
import ChatLogin from "@/views/chat/LoginView.vue";
import ChatList from "@/views/chat/ListView.vue";
import IdentityView from "@/views/agreement/IdentityView.vue";
import PromiseView from "@/views/agreement/PromiseView.vue";
import ReferralLogin from "@/views/referral/LoginView.vue";
import ReferralIndex from "@/views/referral/IndexView.vue";
import ReferralAccount from "@/views/referral/AccountView.vue";
import ReferralIncome from "@/views/referral/IncomeView.vue";
import ReferralTotal from "@/views/referral/TotalView.vue";
import ReferralTotals from "@/views/referral/TotalsView.vue";
import ReferralAudit from "@/views/referral/AuditView.vue";
import ReferralInvite from "@/views/referral/InviteView.vue";
import ReferralInvites from "@/views/referral/InvitesView.vue";
import ReferralMy from "@/views/referral/MyView.vue";
import ReferralSeeds from "@/views/referral/SeedsView.vue";
import CommonVideo from "@/views/common/VideoView.vue";
import EssayList from "@/views/essay/essayView.vue";
import EssayDetail from "@/views/essay/detailView.vue";
import AboutView from "@/views/about/aboutView.vue";



const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: { title: '首页' }
    },
    {
        path: '/join',
        name: 'Join',
        component: JoinView,
        meta: { title: '加入我们' }
    },
    {
        path: '/about',
        name: 'about',
        component:  AboutView,
        meta: { title: '关于我们' }
    },
    {
        path: '/user-home/:share_id',
        name: 'user',
        component: UserView,
        meta: { title: '个人主页' }
    },
    // {
    //     path: '/user-card/:share_id',
    //     name: 'card',
    //     component: CardView,
    //     meta: { title: '资料卡' }
    // },
    {
        path: '/user-card/:share_id',
        name: 'card',
        component: UserCard,
        meta: { title: '个人主页' }
    },
    {
        path: '/anti-fraud',
        name: 'anti-fraud',
        component: AntiFraudView,
        meta: { title: '反诈中心' }
    },
    {
        path: '/fmqy/anti-fraud',
        name: 'fmanti-fraud',
        component: FmAntifraud,
        meta: { title: '反诈中心' }
    },
    {
        path: '/fmqy/identity',
        name: 'fmidentity',
        component: FmIdentity,
        meta: { title: '身份认证协议' }
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyView,
        meta: { title: '隐私政策' }
    },
    {
        path: '/fmqy/agreement',
        name: 'fmagreement',
        component: FmAgreement,
        meta: { title: '用户协议' }
    },
    {
        path: '/fmqy/privacy',
        name: 'fmprivacy',
        component: FmPrivacy,
        meta: { title: '隐私政策' }
    },
    {
        path: '/fmqy/services',
        name: 'fmservices',
        component: FmServices,
        meta: { title: '增值服务协议' }
    },
    {
        path: '/promise',
        name: 'promise',
        component: PromiseView,
        meta: { title: '真实承诺协议' }
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: AgreementView,
        meta: { title: '用户协议' }
    },
    {
        path: '/services',
        name: 'services',
        component: ServicesView,
        meta: { title: '增值服务协议' }
    },
    {
        path: '/face_agreement',
        name: 'face',
        component: FaceView,
        meta: { title: '个人服务授权协议' }
    },
    {
        path: '/identity',
        name: 'identity',
        component: IdentityView,
        meta: { title: '身份认证协议' }
    },
    {
        path: '/extend',
        name: 'extend',
        component: ExtendView,
        meta: { title: '兼职红娘推广账户开通协议' }
    },
    {
        path: '/join/policy',
        name: 'policy',
        component: PolicyView,
        meta: { title: '加盟驿站' }
    },
    {
        path: '/download',
        name: 'download',
        component: DownloadView,
        meta: { title: '爱驿站APP下载' }
    },
    {
        path: '/download/fmqy',
        name: 'downloadfmqy',
        component:  () => import('@/views/download/fmqyView.vue'),
        meta: { title: '父母牵缘下载' }
    },
    {
        path: '/download/fmqyfast',
        name: 'downloadfmqyfast',
        component:  () => import('@/views/download/fmqyFast.vue'),
        meta: { title: '父母牵缘下载' }
    },
    {
        path: '/instruction',
        name: 'instruction',
        component: InstructionView,
        meta: { title: '使用说明' }
    },
    {
        path: '/call/select',
        name: 'call-select',
        component: CallSelectView,
        meta: { title: '选择门店' }
    },
    {
        path: '/call/reload',
        name: 'call-reload',
        component: CallReloadView,
        meta: { title: '重新叫号' }
    },
    {
        path: '/call/apply',
        name: 'call-apply',
        component: CallApplyView,
        meta: { title: '申请叫号' }
    },
    {
        path: '/call/cancel',
        name: 'call-cancel',
        component: CallCancelView,
        meta: { title: '取消叫号' }
    },
    {
        path: '/prefill',
        name: 'prefill',
        component: PrefillView,
        meta: { title: '资料预填' }
    },
    {
        path: '/activity/:act_id',
        name: 'activity',
        component: ActivityView,
        meta: { title: '活动详情' }
    },
    {
        path: '/blind-date/pay/:business_type/:activity_id/:userid/:token',
        name: 'pay',
        // props: true,
        component: PayView,
        meta: { title: '支付方式' }
    },
    {
        path: '/callback/ali/:*',
        name: 'ali',
        // props: true,
        component: AliView,
        meta: { title: '支付回调' }
    },
    {
        path: '/chat/login',
        name: 'chat-login',
        component: ChatLogin,
        meta: { title: '登录' }
    },
    {
        path: '/chat/list:*',
        name: 'chat-list',
        component: ChatList,
        meta: { title: '用户列表' }
    },
    {
        path: '/referral/login',
        name: 'referral-login',
        component: ReferralLogin,
        meta: { title: '邀请码' }
    },
    {
        path: '/referral/index:*',
        name: 'referral-index',
        component: ReferralIndex,
        meta: { title: '邀请码' }
    },
    {
        path: '/referral/account',
        name: 'referral-account',
        component: ReferralAccount,
        meta: { title: '收款账号' }
    },
    {
        path: '/referral/income',
        name: 'referral-income',
        component: ReferralIncome,
        meta: { title: '收益' }
    },
    {
        path: '/referral/total',
        name: 'referral-total',
        component: ReferralTotal,
        meta: { title: '累计收益' }
    },
    {
        path: '/referral/audit:*',
        name: 'referral-audit',
        component: ReferralAudit,
        meta: { title: '邀请码申请' }
    },
    {
        path: '/referral/invite',
        name: 'referral-invite',
        component: ReferralInvite,
        meta: { title: '累计邀请' }
    },
    {
        path: '/referral/invites:*',
        name: 'referral-invites',
        component: ReferralInvites,
        meta: { title: '周期邀请明细' }
    },
    {
        path: '/referral/totals:*',
        name: 'referral-totals',
        component: ReferralTotals,
        meta: { title: '周期收益明细' }
    },
    {
        path: '/referral/my',
        name: 'referral-my',
        component: ReferralMy,
        meta: { title: '我的' }
    },
    {
        path: '/referral/seeds',
        name: 'referral-seeds',
        component: ReferralSeeds,
        meta: { title: '下层邀请收益' }
    },
    {
        path: '/common/video',
        name: 'common-video',
        component: CommonVideo,
        meta: { title: '兼职红娘邀请码介绍' }
    },
    {
        path: '/essay',
        name: 'essay',
        component: EssayList,
        meta: { title: '情感驿站' }
    },
    {
        path: '/essaydetail:*',
        name: 'essay-detail',
        component: EssayDetail,
        meta: { title: '情感驿站' }
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/faq/faqView.vue'),
        meta: { title: '功能介绍' }
    },
    {
        path: '/faq/play:*',
        name: 'faqplay',
        component: () => import('@/views/faq/VideoView.vue'),
        meta: { title: '功能介绍' }
    },
    {
        path: '/faqdetail:*',
        name: 'faqdetail',
        component: () => import('@/views/faq/detailView.vue'),
        meta: { title: '功能介绍' }
    },
    {
        path: '/audit/login',
        name: 'auditLogin',
        component: () => import('@/views/audit/LoginView.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/audit/card',
        name: 'auditCard',
        component: () => import('@/views/audit/CardView.vue'),
        meta: { title: '牵缘审核' }
    },
    {
        path: '/su/identity',
        name: 'suidentity',
        component: () => import('@/views/agreement/su/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/su/agreement',
        name: 'suagreement',
        component: () => import('@/views/agreement/su/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/su/privacy',
        name: 'suprivacy',
        component: () => import('@/views/agreement/su/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/su/services',
        name: 'suservices',
        component: () => import('@/views/agreement/su/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/su/about',
        name: 'suabout',
        component: () => import('@/views/agreement/su/aboutView.vue'),
        meta: { title: '关于我们' }
    },
    {
        path: '/ceshi/cs',
        name: 'ceshics',
        component: () => import('@/views/ceshi/csView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/video:*',
        name: 'videos',
        component: () => import('@/views/video/VideoView.vue'),
        meta: { title: '功能介绍' }
    },
    {
        path: '/face_verify:*',
        name: 'face_verify',
        component: () => import('@/views/face/FaceView.vue'),
        meta: { title: '实名认证' }
    },
    {
        path: '/face_result:*',
        name: 'face_result',
        component: () => import('@/views/face/ResultView.vue'),
        meta: { title: '实名认证结果' }
    },
    {
        path: '/xqw/identity',
        name: 'xqwidentity',
        component: () => import('@/views/agreement/xqw/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/xqw/agreement',
        name: 'xqwagreement',
        component: () => import('@/views/agreement/xqw/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/xqw/privacy',
        name: 'xqwprivacy',
        component: () => import('@/views/agreement/xqw/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/xqw/services',
        name: 'xqwservices',
        component: () => import('@/views/agreement/xqw/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/xqw/about',
        name: 'xqwabout',
        component: () => import('@/views/agreement/xqw/aboutView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/download/ayz/su',
        name: 'downloadayzsu',
        component: () => import('@/views/download/ayzsu.vue'),
        meta: { title: '江苏相亲网下载' }
    },
    {
        path: '/download/su/xqw',
        name: 'downloadsuxqw',
        component: () => import('@/views/download/su.vue'),
        meta: { title: '江苏相亲网下载' }
    },
    {
        path: '/ayzsu/identity',
        name: 'ayzsuidentity',
        component: () => import('@/views/agreement/ayzsu/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/ayzsu/agreement',
        name: 'ayzsuagreement',
        component: () => import('@/views/agreement/ayzsu/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/ayzsu/privacy',
        name: 'ayzsuprivacy',
        component: () => import('@/views/agreement/ayzsu/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/ayzsu/services',
        name: 'ayzsuservices',
        component: () => import('@/views/agreement/ayzsu/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/ayzsu/about',
        name: 'ayzsuabout',
        component: () => import('@/views/agreement/ayzsu/aboutView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/fuqy/mini',
        name: 'fuqymini',
        component: () => import('@/views/mini/miniView.vue'),
        meta: { title: '父母牵缘' }
    },
    {
        path: '/fuqy/relink',
        name: 'fuqyrelink',
        component: () => import('@/views/mini/relinkView.vue'),
        meta: { title: '父母牵缘' }
    },
    {
        path: '/wan/identity',
        name: 'wanidentity',
        component: () => import('@/views/agreement/wan/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/wan/agreement',
        name: 'wanagreement',
        component: () => import('@/views/agreement/wan/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/wan/privacy',
        name: 'wanprivacy',
        component: () => import('@/views/agreement/wan/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/wan/services',
        name: 'wanservices',
        component: () => import('@/views/agreement/wan/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/wan/about',
        name: 'wanabout',
        component: () => import('@/views/agreement/wan/aboutView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/iossu/identity',
        name: 'iossuidentity',
        component: () => import('@/views/agreement/iossu/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/iossu/agreement',
        name: 'iossuagreement',
        component: () => import('@/views/agreement/iossu/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/iossu/privacy',
        name: 'iossuprivacy',
        component: () => import('@/views/agreement/iossu/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/iossu/services',
        name: 'iossuservices',
        component: () => import('@/views/agreement/iossu/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/iossu/about',
        name: 'iossuabout',
        component: () => import('@/views/agreement/iossu/aboutView.vue'),
        meta: { title: '关于我们' }
    },
    {
        path: '/banglian/identity',
        name: 'banglianidentity',
        component: () => import('@/views/agreement/banglian/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/banglian/agreement',
        name: 'banglianagreement',
        component: () => import('@/views/agreement/banglian/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/banglian/privacy',
        name: 'banglianprivacy',
        component: () => import('@/views/agreement/banglian/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/banglian/services',
        name: 'banglianservices',
        component: () => import('@/views/agreement/banglian/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/banglian/about',
        name: 'banglianabout',
        component: () => import('@/views/agreement/banglian/aboutView.vue'),
        meta: { title: '关于我们' }
    },
    {
        path: '/xxxqw/identity',
        name: 'xxxqwidentity',
        component: () => import('@/views/agreement/xxxqw/IdentityView.vue'),
        meta: { title: '身份认证协议' }
    },
    {
        path: '/xxxqw/agreement',
        name: 'xxxqwagreement',
        component: () => import('@/views/agreement/xxxqw/AgreementView.vue'),
        meta: { title: '用户协议' }
    },
    {
        path: '/xxxqw/privacy',
        name: 'xxxqwprivacy',
        component: () => import('@/views/agreement/xxxqw/PrivacyView.vue'),
        meta: { title: '隐私政策' }
    },
    {
        path: '/xxxqw/services',
        name: 'xxxqwservices',
        component: () => import('@/views/agreement/xxxqw/ServicesView.vue'),
        meta: { title: '增值服务协议' }
    },
    {
        path: '/xxxqw/about',
        name: 'banglianabout',
        component: () => import('@/views/agreement/xxxqw/aboutView.vue'),
        meta: { title: '版权说明' }
    },{
        path: '/download/xxxqw',
        name: 'downloadsuxxxqw',
        component: () => import('@/views/download/xxxqw.vue'),
        meta: { title: '江苏相亲网下载' }
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
